import React, { useEffect, useState } from "react";
import styles from "./SubscriptionDetails.module.css";
import { themeColors } from "../../Components/theme";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { numberWithCommas } from "../../Services/booking";
import axios from "axios";
import { url } from "../../Values/constants";
import moment from "moment";
import Loading from "../../Components/Loading/Loading";
import {
  getFormattedDate,
  getFormattedDateForSubscription,
} from "../../Values/utils";
import { firestore } from "../../Firebase";
import axiosHandler from "../../Services/axiosHandler";
import { googleAnalytics } from "../../Services/users";
import { ReadProSubscriptionDetails } from "../../Components/mockData";
import YourMarketingPlan from "../YourMarketingPlan/YourMarketingPlan";
import CenteredPopUp from "../../Components/CenteredPopUp/CenteredPopUp";
import SubscriptionTable from "./SubscriptionPopup";
import { creditHistory, readOrderHistory } from "../../Services/pgi";
import {setCurrentRoute } from "../../Redux/actions";
import { useLocation } from "react-router-dom";

const SubscriptionDetails = ({
  theme,
  validTill,
  organizationData,
  userPreference,
  authToken,
  user,
  organization,
}: any) => {
  const [data, setData] = useState<any[]>([]);
  const [load, setLoad] = useState(false);
  const [total, setTotal] = useState("");
  const [isGACalled, setIsGACalled] = useState<any>(false);
  const [isWAActive, setIsWAActive] = useState<any>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const serviceIds = ["13733","13737"];
  const soId = user?.user_super_oid;
  const [pageNo, setPageNo] = useState('1');
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [nextPageAvailable, setNextPageAvailable] = useState(true);
    const [totalBalance, setTotalBalance] = useState("0");
     const [cRoute,setCRoute]=useState("") 
     const location: any = useLocation();
         const dispatcher = useDispatch();                    
                        useEffect(() => {
                          dispatcher(setCurrentRoute(location.pathname))
                          setCRoute(location.pathname)
                        }, [location]);
    


    useEffect(() => {
            const fetchHistory = async () => {
                try {
                    setLoading(true);
                    // const data = await readOrderHistory(serviceIds, soId, pageNo,(data: any) => setNextPageAvailable(data),true);
                    const data = await creditHistory(serviceIds, soId,(data: any) => setTotalBalance(data));
                    const WAdata = await readOrderHistory(["13739"], soId, pageNo,(data: any) => setNextPageAvailable(data));
                    // console.log("WAdatadatadatadata",data)
                    // setWaData(WAdata);
                    {WAdata.length!==0 && setIsWAActive(true)}
                    
                    setHistoryData(data);
                    setLoading(false);
                } catch (error) {
                    console.error("Error fetching history:", error);
                    setLoading(false);
                }
            };
    
            fetchHistory();
        }, [pageNo,soId]);

  useEffect(() => {
    if (isGACalled === false) {
      if (user?.uid && user?.profile) {
        setIsGACalled(true);
        googleAnalytics("Subscription_Screen", user);
      }
    }
  }, [user]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoad(true);
        // axios.defaults.headers.common['x-access-token'] = authToken;
        const res = await axiosHandler.get(url + "/packageDetails/fetchAll", {
          params: { organization_id: user.organization_id },
        });
        // console.log("rede", res.data.data);

        if (res.data.data.length === 0 && organizationData.admin_email_id) {
          firestore
            .collection("organizations")
            .where("admin_email_id", "==", organizationData.admin_email_id)
            .get()
            .then((querySnapshot) => {
              let data1: any = [];
              querySnapshot.forEach((doc) => {
                // console.log("rishabh",formattedDate)
                data1.push({
                  valid_till: new Date(doc.data().valid_till.toDate()),
                  issued_licences: doc.data().no_of_employees,
                  Oid: doc.data().oid,
                  package_email_id: doc.data().package_email_id,
                });
              });

              data1 = data1.filter(
                (item: any) => new Date(item.valid_till) >= new Date()
              );
              setData(data1);
              let totalLicenses = 0;
              data1.forEach((val: any) => {
                const issuedLicenses = parseInt(val.issued_licences);
                if (!isNaN(issuedLicenses)) {
                  totalLicenses += issuedLicenses;
                }
              });
              setTotal(totalLicenses > 0 ? totalLicenses.toString() : "");
            })
            .catch((error) => {
              console.error(
                "Error fetching organization data from firebase:",
                error
              );
            });
        } else {
          let data1 = res.data.data;
          data1 = data1.filter(
            (item: any) => new Date(item.valid_till) >= new Date()
          );
          setData(data1);
          let totalLicenses = 0;
          data1.forEach((val: any) => {
            const issuedLicenses = parseInt(val.issued_licences);
            if (!isNaN(issuedLicenses)) {
              totalLicenses += issuedLicenses;
            }
          });
          setTotal(totalLicenses > 0 ? totalLicenses.toString() : "");
        }
        setLoad(false);
      } catch (error) {
        console.error("Error fetching subscription details:", error);
        setLoad(false);
      }
    };

    if (authToken) {
      fetchData();
    }
  }, [authToken, user, organizationData]);

  let totalLicenses = organizationData && organizationData.no_of_employees;
  let costPerLicense =
    organizationData && Number(organizationData.cost_per_license);
  let totalAmount = totalLicenses * costPerLicense;
  const history = useHistory();
  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const tdStyles = {
    backgroundColor: theme
      ? themeColors.tdBackgroundColor
      : themeColors.tdBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: "1rem",
    // textAlign: "center"
  };
  const trBorderStyles = {
    borderBottomColor: theme
      ? `1px solid ${themeColors.trBorderColor}`
      : `1px solid ${themeColors.trBorderColorDark}`,
  };
  const thStyles = {
    backgroundColor: theme
      ? themeColors.thBackgroundColor
      : themeColors.thBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: "1rem",
  };

  const onClickHandler = () => {
    setOpenModal(true);
    document.body.classList.add("no-overflow");
  };

  return (
    <div className={styles.parent} style={containerStyles}>
      {load === true && <Loading />}

      <div className={styles.container}>
        <div className={styles.CardSmall}>
          <span className={styles.ReadProSubscriptionValidity}>
            ReadPro Subscription validity:
            <span className={styles.textstyle1}>
              {" "}
              {getFormattedDateForSubscription(organizationData.valid_till)}
            </span>
          </span>
          <div className={styles.ReadProSubscriptionDetails}>
            <div className={styles.ReadProSubscriptionEle}>
              <div className={styles.ReadProSubscriptionLebel}>Email Id</div>
              <div className={styles.ReadProSubscriptionData}>{user.user_email}</div>
            </div>
            <div className={styles.ReadProSubscriptionEle}>
              <div className={styles.ReadProSubscriptionLebel}>OID</div>
              <div className={styles.ReadProSubscriptionData}>{user.user_oid}</div>
            </div>
            {/* <div className={styles.ReadProSubscriptionEle}>
              <div className={styles.ReadProSubscriptionLebel}>Total Licences</div>
              <div className={styles.ReadProSubscriptionData}>{totalBalance}</div>
            </div> */}
          </div>
          <span className={`${styles.CtaUnderlined} ${styles.AngleArrow}`} onClick={()=>onClickHandler()}>See all details</span>
         {(user.profile==="Admin" && isWAActive) && <span className={styles.ToEnjoyUninterruptedService}>
            To enjoy uninterrupted service , please renew your subscription on
            time
            {/* <span  className={styles.CtaOutlined} 
             onClick={() => {
              history.push("/whatsappRechargePlans");
            }}>Renew Now</span> */}
          </span>}
        </div>

        {/* <div
          className="card p-4 shadow-sm"
          style={{
            borderBottomLeftRadius: "50px",
            borderBottomRightRadius: "50px",
            ...cardContainerStyles,
          }}
        >
           {userPreference.show_subscription_panel === false && 
        <>
        <h6>
            {" "}
            <i className="fas fa-info-circle"></i> {" "}{" "}
            You dont have access to view this panel . Please contact your admin.
          </h6>
        </>
        }
           {userPreference.show_subscription_panel === true && 
        <>
     
          <h6>
            {" "}
            <i className="fas fa-info-circle"></i> Your Renewal Date is on <b>{getFormattedDate(organizationData.valid_till)}</b> , To Enjoy Uninterrupted Services, Please renew your
            subscription.
          </h6>
          <h6>
            {" "}
            <i className="fas fa-info-circle"></i> Please go through this link to check our privacy policy <a href="https://read-pro.in/privacy-policy/index.html" target="_blank">Know More</a>
          </h6>
        </>
        }
        </div> */}

        {userPreference.show_subscription_panel === true && (
          <>
            <div>
              {/* <div className="mt-4" style={{ width: "60%" }}>
                <h5 className="fw-bold">
                  Subscription Details ( Oid :{" "}
                  {organizationData.oid ? organizationData.oid : ""})
                </h5>
                <div className="w-100">
                  <table
                    className="table shadow rounded bg-white"
                    style={{ backgroundColor: "red" }}
                  >
                    <thead className="bg-light">
                      <tr>
                        <th style={{ ...thStyles, textAlign: "center" }}>
                          S.No
                        </th>
                        <th style={{ ...thStyles, textAlign: "center" }}>
                          No of Licences
                        </th>
                        <th style={{ ...thStyles, textAlign: "center" }}>
                          Expiration Date
                        </th>
                        <th style={{ ...thStyles, textAlign: "center" }}>
                          Package Email Id
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item: any, index: number) => (
                          <>
                            {console.log("item", item)}
                            <tr className="border-bottom" key={index}>
                              <td style={{ ...tdStyles, textAlign: "center" }}>
                                <p className="fw-normal mb-1">{index + 1}</p>
                              </td>
                              <td style={{ ...tdStyles, textAlign: "center" }}>
                                <p className="fw-normal mb-1">
                                  {item.issued_licences}
                                </p>
                              </td>
                              <td style={{ ...tdStyles, textAlign: "center" }}>
                                <p className="fw-normal mb-1">
                                  {getFormattedDate(item.valid_till)}
                                </p>
                              </td>
                              <td style={{ ...tdStyles, textAlign: "center" }}>
                                <p className="fw-normal mb-1">
                                  {item.package_email_id}
                                </p>
                              </td>
                            </tr>
                          </>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={3}
                            style={{ ...tdStyles, textAlign: "center" }}
                          >
                            No subscription details available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td style={{ ...tdStyles, textAlign: "center" }}>
                          <p className="fw-bold mb-1">
                            {data.length > 0 ? "Total" : ""}
                          </p>
                        </td>
                        <td style={{ ...tdStyles, textAlign: "center" }}>
                          <p className="fw-bold mb-1">{total}</p>
                        </td>
                        <td style={{ ...tdStyles, textAlign: "center" }}>
                          <p className="fw-bold mb-1">{}</p>
                        </td>
                        <td style={{ ...tdStyles, textAlign: "center" }}>
                          <p className="fw-bold mb-1">{}</p>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div> */}
              {/* <div className="mt-4" style={{ width: "35%" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h6 className="fw-bold">Next Payment</h6>
              <h6
                className={styles.historyLink}
                onClick={() => {
                  history.push("/SubscripTionHistory");
                }}
              >
                Payment History
              </h6>
            </div>
            <div
              className="card p-4 shadow d-flex flex-row justify-content-between"
              style={cardContainerStyles}
            >
              <div>
                <h6 className="fw-bold">{validTill}</h6>
                <h6>(Monthly)</h6>
              </div>
              <div>
                <h4> ₹ {numberWithCommas(totalAmount)}</h4>
                <p className="text-end">*Excluding Tax</p>
              </div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-3">
              <button
                className={styles.button}
                onClick={() => {
                  history.push("/upgradeUsers");
                }}
              >
                Upgrade User/ Add-Ons
              </button>
            </div>
          </div> */}
            </div>
          </>
        )}

        {(user.profile==="Admin" && isWAActive) && <YourMarketingPlan />}

        {openModal && 
          <CenteredPopUp
            setModal = {setOpenModal}
            children = {<SubscriptionTable 
              data={historyData}
              totalLicences={totalBalance} 
              activeTill={organizationData.valid_till} />}
            modiferClass = {styles.SubscriptionPopup}
            closeIcon = {true}
          />
        }

      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    validTill: state.organization.organizationData.valid_till,
    organizationData: state.organization.organizationData,
    userPreference: state.userPreference.data,
    authToken: state.user.authToken,
    user: state.user.data,
    organization: state.organization,
  };
};

export default connect(mapStateToProps)(SubscriptionDetails);